import styled, {CSSObject} from 'styled-components';

export const TextField = styled.input<{placeholderStyles?: CSSObject}>`
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(43, 46, 57, 0.1);
  border: none;
  border-radius: 8px;
  font-size: 12px;
  line-height: 32px;
  padding: 0 16px;
  width: 100%;
  &::-webkit-input-placeholder {
    ${props => props.placeholderStyles ?? {}};
    font-style: italic;
  }
  &:-ms-input-placeholder {
    ${props => props.placeholderStyles ?? {}};
    font-style: italic;
  }
`;

export const LargeTextField = styled(TextField)`
  line-height: 40px;
  padding: 0 24px;
  font-size: 14px;
`;
